import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DiscardWarningSummary } from '../../utils/discard-threshold.util';
import { displayAsPercent } from '../../utils/helper';

/**
 * Informational warning shown on study load and after a calculation when a large share of the run was
 * discarded, or an instrument reported a high true-error rate. Purely advisory — a single OK button,
 * and the operator is free to proceed.
 */
@Component({
  selector: 'app-discard-warning-dialog',
  templateUrl: './discard-warning-dialog.component.html',
  styleUrl: './discard-warning-dialog.component.scss'
})
export class DiscardWarningDialogComponent {
  readonly dialogRef = inject(MatDialogRef<DiscardWarningDialogComponent>);
  readonly data = inject<DiscardWarningSummary>(MAT_DIALOG_DATA);

  /** Backend rates are bare proportions, so display always scales by 100. */
  asPercent(value: number): string {
    return displayAsPercent(value, 100);
  }

  close(): void {
    this.dialogRef.close();
  }
}
